export interface Bonus {
  number: string;
  title: string;
  description: string;
  imageUrl: string;
}

export const bonuses: Bonus[] = [
  {
    number: "BONO 01",
    title: "Manual de Musculación",
    description:
      "Una guía práctica de biomecánica básica que te ayuda a entender cómo funciona cada ejercicio, qué músculos se activan y cómo enseñarlo correctamente, aumentando tu seguridad y autoridad.",
    imageUrl:
      "https://cdn.magicpatterns.com/uploads/jx3WikydB9zvSsrgEjzL2L/bono_11.png",
  },
  {
    number: "BONO 02",
    title: "Guía de Ejecución Correcta",
    description:
      "Un checklist directo con los errores más comunes y puntos clave, permitiéndote corregir a tus alumnos de forma rápida y objetiva.",
    imageUrl:
      "https://cdn.magicpatterns.com/uploads/7FKHmXo8E9rxp2dbFj76iC/bono_22.png",
  },
  {
    number: "BONO 03",
    title: "150 Recetas Fitness",
    description:
      "Un material listo con recetas que puedes enviar a tus alumnos para agregar valor, mejorar la experiencia y aumentar la retención.",
    imageUrl:
      "https://cdn.magicpatterns.com/uploads/wGfSTsCJL5uAXYnj5kmaBr/bono_33.png",
  },
  {
    number: "BONO 04",
    title: "Planilla de Periodización Automatizada",
    description:
      "Una planilla lista que facilita la creación de entrenamientos organizados, ayudando en la progresión y ahorrando tiempo.",
    imageUrl:
      "https://cdn.magicpatterns.com/uploads/o4xauDTYqGWuuaVbwD13jU/bono_44.png",
  },
];
